import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Alert, AlertType } from '../alert.model';

export interface DialogData {
  titol: string;
  text: string;
  tipus: AlertType;
  botoCancelar: boolean;
  botoAcceptar: boolean;
  showSpin: boolean;
}

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css']
})
export class AlertDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  ngOnInit(): void {    
  }
  
  cssClass() {
    if (!this.data) {
        return;
    }

    // console.log(this.data.tipus);
    // return css class based on alert type
    switch (this.data.tipus) {
        case AlertType.Success:
            return 'alert alert-success';
        case AlertType.Error:
            return 'alert alert-danger';
        case AlertType.Info:
            return 'alert alert-info';
        case AlertType.Warning:
            return 'alert alert-warning';
    }
}
}
